/* tslint:disable */

declare var Object: any;
export interface CountryInterface {
  "iso"?: string;
  "name"?: string;
  "nicename"?: string;
  "iso3"?: string;
  "numcode"?: string;
  "phonecode"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class Country implements CountryInterface {
  "iso": string;
  "name": string;
  "nicename": string;
  "iso3": string;
  "numcode": string;
  "phonecode": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: CountryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Country`.
   */
  public static getModelName() {
    return "Country";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Country for dynamic purposes.
  **/
  public static factory(data: CountryInterface): Country{
    return new Country(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Country',
      plural: 'Countries',
      path: 'Countries',
      idName: 'id',
      properties: {
        "iso": {
          name: 'iso',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "nicename": {
          name: 'nicename',
          type: 'string'
        },
        "iso3": {
          name: 'iso3',
          type: 'string'
        },
        "numcode": {
          name: 'numcode',
          type: 'string'
        },
        "phonecode": {
          name: 'phonecode',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
